<form [formGroup]="form">
    <div class="phone-section">
        <label for="phone-number" [class]="labelClass" appRequiredField="{{ mobileControlName }}">{{ label }}</label>

        <div class="phone-input form-control rounded-4" [ngClass]="{'disabled-input': form.get(mobileControlName)?.disabled}">

            <select id="country-code" class="custom-select" [formControlName]="mobileCodeControlName">
          <option *ngFor="let country of countryCodes" [value]="country.code">
            {{ country.flag }} {{ country.code }}
          </option>
        </select>

            <input type="tel" id="phone-number" placeholder="Mobile number" [formControlName]="mobileControlName" (input)="onInput($event)" class="phone-number-input">
        </div>

        <div class="text-danger" *ngIf="form.get(mobileControlName)?.invalid && (form.get(mobileControlName)?.dirty || form.get(mobileControlName)?.touched)">
            <div *ngIf="form.get(mobileControlName)?.errors?.['required']">
                This field is required
            </div>
        </div>
    </div>
</form>